import styled from "styled-components";
import { FC, useState, useContext } from "react";

// import { Star } from "../../assets/Star";
import { motion } from "framer-motion";
import { Star } from "../../assets/Star";
import { T } from "../../styles/Theme";
import axios from "axios";
import { AnswersContext } from "../../contexts/AnswersContext";
import { ADVISER_IDENTIFIER, ANSWERS_API_URL } from "../../env";
import { RateSelectedGTM } from "../../utils/GoogleTagManager";
import { DataContext } from "../../contexts/DataContext";
import { getActivitiesToDo, getConectedDevicesAlternatives, getPlanSelected } from "../../utils/common";
import { uploadCommentRequest } from "../../utils/requests";
import CommentBox from "../CommentBox";


const YellowStar: string = "rgb(255, 205, 60)";
const InactiveStar: string = "#E5E5E5";

const RatingStars: FC = () => {
  const [rating, setRating] = useState<number>(0);
  const [answers, setAnswers] = useContext(AnswersContext);
  const [commentBoxActive, setCommentBoxActive] = useState<boolean>(false);

  const [finalForm,] = useContext(DataContext);

  if (window) {
    // var pollID = sessionStorage.getItem("pollID");
    // var FlagPollID = sessionStorage.getItem("FLAG-Rate-pollID") || undefined;
  }

  //   useEffect(() => {
  //     var RateStars = sessionStorage.getItem("RateStars") || 0;

  //     const config = {
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     };

  //     if (pollID === FlagPollID) {
  //       console.log("No petition");
  //       console.log({ rate: rating });
  //       setRating(Number(RateStars));
  //     } else {
  //       if (rating !== 0) {
  //         axios.post();
  //       }
  //     }
  //   }, [rating]);

  const handleClick = async (i: any) => {
    // if (pollID !== FlagPollID && rating === 0) {
    //   setRating(i + 1);
    //   sessionStorage.setItem("RateStars", i + 1);
    // }
    if (!answers.rate) {
      setAnswers({ ...answers, rate: i + 1 });
      const data = {
        answer_id: answers.idAnswer,
        rate: i + 1,
      }
      RateSelectedGTM(window, i + 1, answers.email, answers.phone, getPlanSelected(finalForm), getActivitiesToDo(finalForm), getConectedDevicesAlternatives(finalForm))
      // axios.post(`${ANSWERS_API_URL}/api/v1/answers-rates/`, data).then(res => console.log(res.status));
      axios.post(`${ANSWERS_API_URL}/${ADVISER_IDENTIFIER}/answers/rates/`, data)
        .then(res => console.log(res.status))
        .finally(() => {
          setCommentBoxActive(true);
        })
      }
      setRating(i + 1);
    }

    const handleSendComment = async () => {
      if (!!answers.comment) {
        const data = {
          answer_id: answers.idAnswer,
          comment: answers.comment,
        }
        uploadCommentRequest(data).then(res => console.log(res.status))
      }
    };

    if (commentBoxActive) {
      return (
        <CommentBoxContainer>
          <CommentBox
            onSubmitComment={() => handleSendComment()}
            placeholder="¡Tu feedback es importante! Cuéntanos tus impresiones..."
          />
        </CommentBoxContainer>
      );
    }

  return (
    <RatingStyled>
      <h4>¿Te pareció útil esta recomendación?</h4>
      <div className="StarContainer">
        {[1, 2, 3, 4, 5].map((star, i) => (
          <motion.div
            key={`star${i}`}
            whileTap={{ scale: 0.8 }}
            whileHover={{ scale: 1.2 }}
            onClick={() => handleClick(i)}
          >
            <Star fill={rating >= i + 1 ? YellowStar : InactiveStar} />
          </motion.div>
        ))}
      </div>
    </RatingStyled>
  );
};

export default RatingStars;

const CommentBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  max-width: 525px;

  @media (max-width: 640px) {
    padding: 0 40px;
  }
`;

const RatingStyled = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  h4 {
    margin: 12px 0;
    max-width: 190px;
    font-weight: 700;
    font-size: 18px;
    text-align: center;
    color: #4c4c4c;
  }

  .StarContainer {
    transform: scale(1.4);
    cursor: pointer;
    margin-bottom: 15px;
    display: flex;

    svg {
      margin: 0 5px;
    }
  }

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
`;
